import React, { useEffect, useMemo, useState } from 'react';
//components
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';
import { Visibility } from 'components/Visibility';
import { Column, Row } from 'components/Layout/Grid';
import Loading from 'components/Loading';
import Table from 'components/Table';
import Text from 'components/Text';
//context
import { useDetailsQuoteContext } from 'contexts/DetailsQuote';
//services
import QuoteBionexoServices from "services/quoteBionexo.service";
//generics
import { orderModel } from 'pages/Quotes/MoneyRecordedQuotes/models';
import { IPreOrders } from './interface';

/**
 * @main PortalOrderDropdown is the main exported component
 */
export const PortalOrderDropdown: React.FC<IPreOrders> = ({ code }) => {
  const { finishUpdateOrder, preOrderDetails, setPreOrderDetails } = useDetailsQuoteContext();

  const index = preOrderDetails?.findIndex((x: IPreOrders) => x.createdAt);
  const visible = preOrderDetails ? preOrderDetails.length > 0 : false;

  const _quoteBionexoServices = new QuoteBionexoServices();

  const getPreOrderDetails = async (quotationCode: string) => {
    const result = await _quoteBionexoServices.getPreOrderDetails(quotationCode);
    if (result?.data)
      setPreOrderDetails(result?.data);
    else
      setPreOrderDetails([]);
  };

  useEffect(() => {
    setPreOrderDetails(undefined);
    getPreOrderDetails(code);
  }, [finishUpdateOrder]);

  const MemoOrderDetailsTable = useMemo(() => (
    <Table
      tableOrder=""
      totalPages={1}
      currentPage={0}
      model={orderModel}
      portalCustomHeader
      onReload={() => { }}
      setTableOrder={() => { }}
      trackingKey="Detalhes dos Pedidos"
      data={preOrderDetails ?? undefined}
      pageSize={preOrderDetails?.length ?? 1}
    />
  ), [preOrderDetails]);

  return (
    <Column className="animated fadeIn bg-white px-5 py-3">
      <Visibility visible={IsNullOrEmpty(preOrderDetails)}>
        <Row className='justify-center'>
          <Loading onlySpinner size={35} />
        </Row>
      </Visibility>

      <Visibility visible={preOrderDetails ? preOrderDetails?.length >= 0 : false}>
        <Text className={`font-bold color-blue-gray mt-2 mb-3 ${!visible || index === -1 ? 'text-center' : ''}`} size={12}>
          {`${visible && index !== -1 ? 'Detalhamento do pedido' : 'Sem detalhes de resgate para este pedido'}`}
        </Text>
        <Visibility visible={visible && index !== -1}>
          {MemoOrderDetailsTable}
        </Visibility>
      </Visibility>
    </Column>
  );
};
